import useSchema from "hooks/useSchema";
import { useDispatch } from "react-redux";
import { actions as notificationActions } from "reducers/notification";
import * as i18n from "util/i18n";
import * as Yup from "yup";

export const useValidations = (accounts, billToPay, hasBilling, dynamicSchema, isCABpayment) => {
    const dispatch = useDispatch();
    const { numberRequired, stringRequired } = useSchema();

    function validateAmount(value) {
        // eslint-disable-next-line react/no-this-in-sfc
        const { debitAccountId = "" } = this.parent;
        const selected = accounts.find((_account) => _account.productId === debitAccountId);

        if (value.amount < billToPay.minAmount1) {
            dispatch(
                notificationActions.showNotification(
                    i18n.get("payments.service.min.amount.error", null, { minAmount: billToPay.minAmount1 }),
                    "error",
                    ["newServicePaymentPage"],
                ),
            );
        }
        if (value.amount > billToPay.maxAmount1) {
            dispatch(
                notificationActions.showNotification(
                    i18n.get("payments.service.max.amount.error", null, { maxAmount: billToPay.maxAmount1 }),
                    "error",
                    ["newServicePaymentPage"],
                ),
            );
        }
        if (value.amount > selected?.availableBalance) {
            dispatch(
                notificationActions.showNotification(i18n.get("transfers.insuficient.amount.error"), "error", [
                    "newServicePaymentPage",
                ]),
            );
        }
        return (
            value.amount <= selected?.availableBalance ||
            value.amount >= billToPay.minAmount1 ||
            value.amount <= billToPay.maxAmount1
        );
    }

    const amountValidation = hasBilling
        ? {
              amountField: Yup.object()
                  .shape({
                      amount: numberRequired,
                  })
                  .test("availableAmount", i18n.get("transfer.amount.error"), validateAmount),
          }
        : {};

    const accountValidation =
        hasBilling || isCABpayment
            ? {
                  debitAccountId: stringRequired,
              }
            : {};

    const validationSchema = Yup.object().shape({
        companyCode: stringRequired.nullable(),
        paymentType: stringRequired,
        ...amountValidation,
        ...accountValidation,
        ...dynamicSchema,
    });

    return { validationSchema };
};

export default useValidations;
